import { defineNuxtRouteMiddleware } from '#app'

const LEGACY_LEARNING_PROGRESS_PATH = /^\/kids\/([^/]+)\/(math|ela)\/(learning-plan|reports|skill-report|mastery-map)(\/.*)?$/
const MASTERY_MAP_REPORT_PATH = /^\/kids\/([^/]+)\/(math|ela)\/(?:learning-progress\/)?mastery-map\/(\d+)\/?$/

const resolveTarget = (path: string): string | null => {
  const report = MASTERY_MAP_REPORT_PATH.exec(path)
  if (report) {
    const [, kid, discipline, assessment] = report
    return `/kids/${kid}/${discipline}/learning-progress/assessments/${assessment}`
  }

  const legacy = LEGACY_LEARNING_PROGRESS_PATH.exec(path)
  if (!legacy) return null

  const [, kid, discipline, section, rest = ''] = legacy
  return `/kids/${kid}/${discipline}/learning-progress/${section}${rest}`
}

export default defineNuxtRouteMiddleware((to) => {
  const target = resolveTarget(to.path)
  if (!target) return

  return navigateTo({
    path: target,
    query: to.query,
    hash: to.hash,
  }, { redirectCode: 301, replace: true })
})
